// extracted by mini-css-extract-plugin
export default {"iframe":"Cerego_iframe__2u4Nq","iframeHidden":"Cerego_iframeHidden__uhyeV","iframeWrapper":"Cerego_iframeWrapper__c4D86","iframeLoader":"Cerego_iframeLoader__Tmtyr"};